import { Component, Input, NgZone, OnInit, OnChanges, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { process, State } from '@progress/kendo-data-query';
import { CityService } from '../../services/city.service';
import { CRMService } from '../../services/crm.service';
import { CSEService } from '../../services/cse.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import {
    City,
    Country,
    EquipmentClass,
    Mode,
    RateIndex,
    SearchCarrierLane,
    SearchMarket,
    SearchModeEquipmentClassTrailerType,
    State as StateProvince,
    TrailerType
} from '../../models/models';

@Component({
    selector: 'carrier-lane-grid',
    templateUrl: './carrier-lane-grid.component.html',
    standalone: false
})
export class CarrierLaneGrid implements OnInit, OnChanges {
    @Input() carrierID: number = 0;
    @Input() isAddLanes: boolean = false;

    @ViewChild(GridComponent, { static: false }) public lanesGrid!: GridComponent;
    @ViewChild(GridComponent, { static: false }) public addLanesGrid!: GridComponent;

    public lanes: SearchCarrierLane[] = [];
    public addSearchLanes: SearchCarrierLane[] = [];
    public addLanesList: SearchCarrierLane[] = [];
    public filteredLanes: SearchCarrierLane[] = [];
    public countryList: Country[] = [];
    public originStateList: StateProvince[] = [];
    public destinationStateList: StateProvince[] = [];
    //private zip3List: Zip3[] = [];
    //public cityList: City[] = [];
    public originMarketList: SearchMarket[] = [];
    public destinationMarketList: SearchMarket[] = [];
    public rateIndexList: RateIndex[] = [];
    public modeList: Mode[] = [];
    public equipmentClassList: EquipmentClass[] = [];
    public trailerTypeList: TrailerType[] = [];
    public modeEquipmentClassTrailerTypeList: SearchModeEquipmentClassTrailerType[] = [];
    public originCountryID: number = 0;
    public originStateID: number = 0;
    public originCityID: number = 0;
    private originCity: City = {} as City;
    public destinationCountryID: number = 0;
    public destinationStateID: number = 0;
    public destinationCityID: number = 0;
    private destinationCity: City = {} as City;
    private rateIndexID: number = 0;
    private rateIndexName: string = "Spot";
    public modeID: number = 0;
    public equipmentClassID: number = 0;
    public trailerTypeID: number = 0;
    public originMarketIDList: number[] = [];
    public destinationMarketIDList: number[] = [];
    public isRoundTrip: boolean = false;
    public ratePerMile: number = 0;
    public isLaneExists: boolean = false;

    public isEdit: boolean = false;
    public isAdd: boolean = false;

    public carrierLaneID: number = 0;


    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'carrierName' }] };
    public gridData: GridDataResult = { data: [], total: 0 };
    public addLanesGridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'carrierName' }] };
    public addLanesGridData: GridDataResult = { data: [], total: 0 };

    public formGroup: UntypedFormGroup = new UntypedFormGroup({
        originCityCtrl: new UntypedFormControl(''),
        destinationCityCtrl: new UntypedFormControl(''),
    });

    constructor(private cityService: CityService, private crmService: CRMService, private cseService: CSEService,
        private ngZone: NgZone, private notificationService: NotificationService,
        private orderService: OrderService, private utilService: UtilService) {
    }

    ngOnInit() {
        this.getCountries();
        this.getRateIndexes();
        //this.getModes();
        this.getSearchModeEquipmentClassTrailerTypes();
        //this.getEquipmentClasses();
        //this.getTrailerTypes();
        this.getCarrierLanes();
        //console.log("ngOnInit");
    }

    ngOnChanges() {
        this.isLaneExists = false;
        this.getCarrierLanes();
        //console.log("ngOnChanges");
    }

    private getCountries() {
        this.cityService.getCountries().subscribe(result => {
            this.countryList = result;
            this.countryList = this.countryList.filter(t => t.abbrev.trim() == "US" || t.abbrev.trim() == "MX" || t.abbrev.trim() == "CA")
            var country = this.countryList.find(t => t.abbrev.trim().toUpperCase() == "US");
            if (country != null) {
                this.originCountryID = country.countryId;
                this.destinationCountryID = country.countryId;
                this.getStates("origin");
                this.getStates("destination");
            }
        });
    }

    private getStates(type: string) {
        if (type == "origin") {
            this.cityService.getStatesByCountryID(this.originCountryID).subscribe(result => {
                this.originStateList = result.resultCollection;
            });
        }
        else if (type == "destination") {
            this.cityService.getStatesByCountryID(this.destinationCountryID).subscribe(result => {
                this.destinationStateList = result.resultCollection;
            });
        }
    }

    private getRateIndexes() {
        this.crmService.getRateIndices().subscribe(result => {
            this.rateIndexList = result;
            var idx = this.rateIndexList.findIndex(t => t.description == "Spot")!;
            if (idx >= 0) {
                this.rateIndexID = this.rateIndexList[idx].rateIndexID;
                this.rateIndexName = this.rateIndexList[idx].description;
            }
        });
    }

    private getSearchModeEquipmentClassTrailerTypes() {
        this.orderService.getAllSearchModeEquipmentClassTrailerType().subscribe(result => {
            this.modeEquipmentClassTrailerTypeList = result.resultCollection;
            this.getModes();
            //this.setDefaults();
        });
    }

    private getModes() {
        //this.orderService.getModes().subscribe(result => {
        //    this.modeList = result;
        //});

        for (var i = 0; i < this.modeEquipmentClassTrailerTypeList.length; i++) {
            var idx = this.modeList.findIndex(t => t.modeID == this.modeEquipmentClassTrailerTypeList[i].modeID);
            if (idx < 0) {
                var mode: Mode = {
                    modeID: this.modeEquipmentClassTrailerTypeList[i].modeID,
                    abbrev: this.modeEquipmentClassTrailerTypeList[i].modeAbbrev,
                    description: this.modeEquipmentClassTrailerTypeList[i].modeDescription,
                    groupEmail: "",
                    defaultTrailerTypeId: 0,
                    includeInLogisticLaneInd: false,
                    sortOrder: this.modeEquipmentClassTrailerTypeList[i].modeSortOrder
                }
                this.modeList.push(mode);
                this.modeList = this.modeList.sort((left, right): number => {
                    if (left.sortOrder < right.sortOrder) return -1;
                    if (left.sortOrder > right.sortOrder) return 1;
                    return 0;
                });
            }
        }
    }

    private getEquipmentClasses() {
        //this.orderService.getEquipmentClasses().subscribe(result => {
        //    this.equipmentClassList = result.resultCollection;
        //});

        var subList = this.modeEquipmentClassTrailerTypeList.filter(t => t.modeID == this.modeID);
        for (var i = 0; i < subList.length; i++) {
            var idx = this.equipmentClassList.findIndex(t => t.equipmentClassID == subList[i].equipmentClassID);
            if (idx < 0) {
                var equipmentClass: EquipmentClass = {
                    equipmentClassID: subList[i].equipmentClassID,
                    abbreviation: subList[i].equipmentClassAbbrev,
                    className: subList[i].equipmentClassName,
                    sortOrder: subList[i].equipmentClassSortOrder
                }
                this.equipmentClassList.push(equipmentClass);
                this.equipmentClassList = this.equipmentClassList.sort((left, right): number => {
                    if (left.sortOrder < right.sortOrder) return -1;
                    if (left.sortOrder > right.sortOrder) return 1;
                    return 0;
                });
            }
        }
    }

    private getTrailerTypes() {
        //this.orderService.getTrailerTypes().subscribe(result => {
        //    this.trailerTypeList = result;
        //});

        var subList = this.modeEquipmentClassTrailerTypeList.filter(t => t.modeID == this.modeID && t.equipmentClassID == this.equipmentClassID && t.allowedOnLanes == true);
        for (var i = 0; i < subList.length; i++) {
            var idx = this.trailerTypeList.findIndex(t => t.trailerTypeID == subList[i].trailerTypeID);
            if (idx < 0) {
                var trailerType: TrailerType = {
                    trailerTypeID: subList[i].trailerTypeID,
                    abbrev: subList[i].trailerTypeAbbrev,
                    description: subList[i].trailerTypeDescription,
                    defaultModeID: subList[i].defaultModeID!,
                    allowedOnLanes: subList[i].allowedOnLanes!,
                    defaultLength: subList[i].defaultLength,
                    defaultWeight: subList[i].defaultWeight,
                    datEquipmentCode: "",
                    datEquipmentTypeId: 0,
                    erpCode: "",
                    includeInLogisticLaneInd: false,
                    sortOrder: subList[i].trailerTypeSortOrder
                }
                this.trailerTypeList.push(trailerType);
                this.trailerTypeList = this.trailerTypeList.sort((left, right): number => {
                    if (left.sortOrder < right.sortOrder) return -1;
                    if (left.sortOrder > right.sortOrder) return 1;
                    return 0;
                });
            }
        }
    }

    public countryChanged(evt: any, type: string) {
        if (evt.target) {
            if (type == "origin") {
                this.originCountryID = parseInt(evt.target.value);
                this.getStates("origin");
            }
            else if (type == "destination") {
                this.destinationCountryID = parseInt(evt.target.value);
                this.getStates("destination");
            }
        }
    }

    public stateChanged(evt: any, type: string) {
        if (type == "origin") {
            this.originMarketList.length = 0;
            this.originMarketIDList.length = 0;
            if (evt.target) {
                this.originStateID = parseInt(evt.target.value);
                this.cityService.getSearchMarketByStateID(this.originStateID).subscribe(result => {
                    this.originMarketList = result.resultCollection;
                });
            }
        }
        else if (type == "destination") {
            this.destinationMarketList.length = 0;
            this.destinationMarketIDList.length = 0;
            if (evt.target) {
                this.destinationStateID = parseInt(evt.target.value);
                this.cityService.getSearchMarketByStateID(this.destinationStateID).subscribe(result => {
                    this.destinationMarketList = result.resultCollection;
                });
            }
        }
        //this.getZip3s();
    }

    public citySTChanged(evt: any, ctrl: string) {
        var cityID = evt;
        console.log("citySTChanged", cityID, ctrl, evt);
        this.cityService.getCityByID(cityID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                var city: City = result.resultCollection[0];
                if (ctrl == "originCityCtrl") {
                    this.originCityID = city.cityID;
                    this.originCity = city;
                    this.cityService.getSearchMarketByID(city.marketID).subscribe(result => {
                        this.originMarketList = result.resultCollection;
                    });
                    //this.getMarkets(city.cityId, "origin");
                    //console.log("citySTChanged:originCity", cityID, this.originCityID, this.destinationCityID, result);
                }
                else if (ctrl == "destinationCityCtrl") {
                    this.destinationCityID = city.cityID;
                    this.destinationCity = city;
                    this.cityService.getSearchMarketByID(city.marketID).subscribe(result => {
                        this.destinationMarketList = result.resultCollection;
                    });
                    //this.getMarkets(city.cityId, "destination");
                    //console.log("citySTChanged:destinationCity", cityID, this.originCityID, this.destinationCityID, result);
                }
            }
            else {
                this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
            }
        });
    }

    public marketChanged(evt: any, type: string) {
        //console.log("marketChanged", type, evt, this.originMarketIDList, this.destinationMarketIDList);
        if (evt.target) {
            if (type == "origin") {
                //this.originStateID = parseInt(evt.target.value);
            }
            else if (type == "destination") {
                //this.destinationStateID = parseInt(evt.target.value);
            }
            this.setCarrierLanes();
        }
    }

    public modeChanged(evt: any) {
        var modeID = evt.target ? evt.target.value : evt;

        if (modeID > 0) {
            var mode = this.modeList.filter(t => t.modeID == modeID);
            if (mode != null && mode.length > 0) {
                var trailerType = this.trailerTypeList.filter(t => t.trailerTypeID == mode[0].defaultTrailerTypeId);

                if (trailerType != null && trailerType.length > 0) {
                    this.trailerTypeID = trailerType[0].trailerTypeID;
                }
            }
            else {
                this.trailerTypeID = 0;
            }
        } else {
            this.trailerTypeID = 0;
        }

        this.equipmentClassID = 0;
        this.trailerTypeID = 0;
        this.equipmentClassList.length = 0;
        this.trailerTypeList.length = 0;

        this.getEquipmentClasses();
        this.getTrailerTypes();
    }

    public equipmentClassChanged(evt: any) {
        var classID = evt.target ? evt.target.value : evt;

        if (classID > 0) {
            var equipmentClass = this.equipmentClassList.filter(t => t.equipmentClassID == classID);
            if (equipmentClass != null && equipmentClass.length > 0) {
                //var trailerType = this.trailerTypeList.filter(t => t.trailerTypeID == equipmentClass[0].default);

                //    if (trailerType != null && trailerType.length > 0) {
                //        this.quoteOrderLine.trailerTypeID = trailerType[0].trailerTypeID;
                //        this.quoteOrderLine.trailerLength = trailerType[0].defaultLength;
                //    }
            }
            else {
                this.equipmentClassID = 0;
            }
        } else {
            this.equipmentClassID = 0;
        }

        this.trailerTypeID = 0;
        this.trailerTypeList.length = 0;

        this.getTrailerTypes();
    }

    public trailerTypeChanged(evt: any) {
        var trailerTypeID = evt.target ? evt.target.value : evt;

        if (trailerTypeID > 0) {
            var trailerType = this.trailerTypeList.filter(t => t.trailerTypeID == trailerTypeID);
            if (trailerType != null && trailerType.length > 0) {
            }
            else {
                this.trailerTypeID = 0;
            }
        } else {
            this.trailerTypeID = 0;
        }

        this.setCarrierLanes();
    }

    private setCarrierLanes() {
        this.addLanesList.length = 0;
        if (this.modeID > 0
            && this.equipmentClassID > 0
            && this.trailerTypeID > 0
            && this.originMarketIDList.length > 0
            && this.destinationMarketIDList.length > 0
        ) {
            var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            for (var o = 0; o < this.originMarketIDList.length; o++) {
                for (var d = 0; d < this.destinationMarketIDList.length; d++) {
                    var lane = this.getNewSearchCarrierLane(this.originMarketIDList[o], this.destinationMarketIDList[d]);
                    lane.createdByEmployeeID = employeeID;
                    this.addLanesList.push(lane);
                }
            }
        }
        this.setAddLanesGrid();
        console.log("setCarrierLanes", this.originMarketIDList, this.destinationMarketIDList, this.addLanesList);
    }

    private getNewSearchCarrierLane(originMarketID: number, destinationMarketID: number) {
        var mode = this.modeList.find(t => t.modeID == this.modeID)!;
        //var equipmentClass = this.equipmentClassList.find(t => t.equipmentClassID == this.equipmentClassID)!;
        var trailerType = this.trailerTypeList.find(t => t.trailerTypeID == this.trailerTypeID)!;
        var oMkt = this.originMarketList.find(t => t.marketID == originMarketID)!;
        var dMkt = this.destinationMarketList.find(t => t.marketID == destinationMarketID)!;
        //console.log("getNewCarrierLaneAdd", originMarketID, destinationMarketID, oMkt, dMkt);

        //var newLane: CarrierLaneAdd = {
        //    isPreferred: true,
        //    truckCount: 0,
        //    ratePerMile: this.ratePerMile,
        //    originCityID: this.originCityID,
        //    originStateID: this.originStateID,
        //    oZip3: this.originCity.zip3 ? this.originCity.zip3 : oMkt.marketCity.zip3,
        //    originMarket: oMkt.name + ' - ' + oMkt.city,
        //    originMarketID: originMarketID,
        //    destinationCityID: this.destinationCityID,
        //    destinationStateID: this.destinationStateID,
        //    dZip3: this.destinationCity.zip3 ? this.destinationCity.zip3 : dMkt.marketCity.zip3,
        //    destinationMarket: dMkt.name + ' - ' + dMkt.city,
        //    destinationMarketID: destinationMarketID,
        //    modeID: this.modeID,
        //    modeAbbrev: mode.abbrev,
        //    modeDescription: mode.description,
        //    trailerTypeID: this.trailerTypeID,
        //    trailerTypeAbbrev: trailerType.abbrev,
        //    trailerTypeDescription: trailerType.description,
        //    isRoundTrip: this.isRoundTrip,
        //    rateIndexID: this.rateIndexID,
        //    rateIndexName: this.rateIndexName,
        //    orderCount: 0,
        //    isDuplicate: false
        //};

        var newSearchLane = {
            carrierID: this.carrierID,
            geocodeLaneID: 0,
            preferred: true,
            ratePerMile: this.ratePerMile,
            oZip3: this.originCity.zip3 ? this.originCity.zip3 : oMkt.zip3,
            oMktDesc: oMkt.marketName + ' - ' + oMkt.marketCity,
            oMarketID: originMarketID,
            oRegionID: oMkt.regionID,
            oStateID: oMkt.stateID,
            dZip3: this.destinationCity.zip3 ? this.destinationCity.zip3 : dMkt.zip3,
            dMktDesc: dMkt.marketName + ' - ' + dMkt.marketCity,
            dMarketID: destinationMarketID,
            dRegionID: dMkt.regionID,
            dStateID: dMkt.stateID,
            modeID: this.modeID,
            modeAbbrev: mode.abbrev,
            mode: mode.description,
            trailerTypeID: this.trailerTypeID,
            trailerTypeAbbrev: trailerType.abbrev,
            trailerType: trailerType.description,
            roundTrip: this.isRoundTrip,
            rateIndexID: this.rateIndexID,
            rateIndexDescription: this.rateIndexName
            //trucksPerWeek: 0,
            //procurements: 0,
            //viewid: "",
            //carrierLaneID: 0,
            //carrierName: "",
            //carrierCode: "",
            //mcNumber: "",
            //scacCode: "",
            //dotNumber: 0,
            //offers: 0,
            //minRate: 0,
            //lastRan: new Date(),
            //oRegionID: 0,
            //dRegionID: 0,
            //originalDisabled: false,
            //originalPreferred: true,
            //originalRatePerMile: this.ratePerMile,
            //originDistributionCenter: "",
            //destinationDistributionCenter: ""
        } as SearchCarrierLane;

        return newSearchLane;
    }

    //private getNewCarrierLane() {
    //    var newLane: CarrierLane = {
    //        carrierLaneId: 0,
    //        carrierId: this.carrierID,
    //        geocodeLaneId: 0,
    //        procurements: 0,
    //        offers: 0,
    //        preferred: false,
    //        ratePerMile: 0,
    //        minRate: 0,
    //        disabled: false,
    //        lastRan: new Date(),
    //        lastRanRate: 0,
    //        minRateDate: new Date(),
    //        carrier: {} as Carrier
    //    };
    //    return newLane;
    //}

    private getCarrierLanes() {
        this.utilService.isLoading = true;
        this.cseService.getSearchCarrierLaneByCarrierID(this.carrierID).subscribe(result => {
            this.lanes = result.resultCollection;
            this.lanes = this.lanes.filter(t => t.preferred == true);
            this.utilService.isLoading = false;
            this.setGrid();
            //console.log("carriers", this.lanes.length);
        });
    }

    private setGrid() {
        this.filteredLanes = Object.assign([], this.lanes);
        this.gridData = process(this.filteredLanes, this.gridState);
        //console.log("setGrid", this.gridData, this.filteredCarriers);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.lanesGrid == null) return;
            this.lanesGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.gridData = process(this.lanes, this.gridState);
    }

    private setAddLanesGrid() {
        this.addLanesGridData = process(this.addLanesList, this.addLanesGridState);
        //console.log("setGrid", this.gridData, this.filteredCarriers);
        this.fitAddLanesColumns();
    }

    private fitAddLanesColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.addLanesGrid == null) return;
            this.addLanesGrid.autoFitColumns();
        });
    }

    public addLanesDataStateChange(state: DataStateChangeEvent): void {
        this.addLanesGridState = state;
        this.addLanesGridData = process(this.addLanesList, this.addLanesGridState);
    }

    public addLaneRowCallback = (context: RowClassArgs) => {
        var lane = context.dataItem as SearchCarrierLane;
        if (lane.notes == "EXISTS") {
            return 'text-danger font-weight-bold'
        }
    }

    public saveAddLanes() {
        this.cseService.saveCarrierLaneFromSearchCarrierLane(this.addLanesList).subscribe(result => {
            this.addLanesList = result.resultCollection;
            this.addLanesGridData = process(this.addLanesList, this.addLanesGridState);
            var numExist = this.addLanesList.filter(t => t.notes == "EXISTS").length;
            var numAdded = this.addLanesList.filter(t => t.notes != "EXISTS").length;
            if (numExist > 0) {
                this.isLaneExists = true;
                this.notificationService.showWarning("Added " + numAdded + " lanes. " + numExist + " lanes already exist.", "WARNING: Lanes Exist");
            }
            else {
                this.isLaneExists = false;
                this.notificationService.showSuccess("Successfully added " + numAdded + " lanes.", "SUCCESS: Add Lanes");
            }
            this.getCarrierLanes();
        });
    }

    public cancelAddLanes() {
        this.originCountryID = 0;
        this.destinationCountryID = 0;
        this.originStateID = 0;
        this.destinationStateID = 0;
        this.originCityID = 0;
        this.destinationCityID = 0;
        this.originMarketIDList.length = 0;
        this.originMarketList.length = 0;
        this.destinationMarketIDList.length = 0;
        this.destinationMarketList.length = 0;
        this.trailerTypeID = 0;
        this.trailerTypeList.length = 0;
        this.equipmentClassID = 0;
        this.equipmentClassList.length = 0;
        this.modeID = 0;
        this.ratePerMile = 0;
        this.isRoundTrip = false;
        this.isLaneExists = false;
        this.setCarrierLanes();
    }

    public edit(carrierLaneID: number) {
        this.carrierLaneID = carrierLaneID;
        this.isEdit = true;
        this.isAdd = false;
    }

    public cancelEdit() {
        this.isEdit = false;
        this.isAdd = false;
    }

    public refreshGrid() {
        this.cancelEdit();
        this.getCarrierLanes();
    }
}
